import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import {
    FEATURE_FLAGS,
    useAccount,
    useAccountConfig,
} from 'modules/taboola-common-frontend-modules/account-configurations';
import { useUserPermissionOrFeatureFlagEnabled } from 'modules/taboola-common-frontend-modules/account-configurations/hooks/useUserPermissionOrFeatureFlagEnabled';

export const usePixelLookalikePermitted = () => {
    const isPermitted = useUserPermissionOrFeatureFlagEnabled(
        'CREATE_PIXEL_PREDICTIVE',
        FEATURE_FLAGS.PIXEL_PREDICTIVE_ENABLED
    );
    const { [FEATURE_FLAGS.CREATE_PBP_EXCLUDED_CUSTOMER_PROFILES_LIST]: rawExcludedCustomerProfiles } =
        useAccountConfig([FEATURE_FLAGS.CREATE_PBP_EXCLUDED_CUSTOMER_PROFILES_LIST]);
    const selectedAccount = useAccount();
    const advertiserType = selectedAccount?.advertiserType;
    const associatedAccountAdvertiserTypes = selectedAccount?.associatedAccountAdvertiserTypes;

    const excludedCustomerProfiles = useMemo(() => {
        let excludedCustomerProfiles = new Set();
        try {
            excludedCustomerProfiles = new Set((rawExcludedCustomerProfiles || '')?.split(','));
        } catch (error) {
            console.error('Error splitting excluded customer profiles', error);
        }
        return excludedCustomerProfiles;
    }, [rawExcludedCustomerProfiles]);

    const isPbpAllowed = useMemo(() => {
        const hasValidAdvertiserType = !excludedCustomerProfiles.has(advertiserType);
        // if there are no associated account advertiser types or at least one is valid, then the user is permitted
        const hasValidAssociatedAccountAdvertiserTypes =
            isEmpty(associatedAccountAdvertiserTypes) ||
            associatedAccountAdvertiserTypes.some(advertiserType => !excludedCustomerProfiles.has(advertiserType));

        return Boolean(isPermitted && hasValidAdvertiserType && hasValidAssociatedAccountAdvertiserTypes);
    }, [excludedCustomerProfiles, advertiserType, associatedAccountAdvertiserTypes, isPermitted]);

    return isPbpAllowed;
};
